// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"a605b768","container":"a3704bef","left":"b510e329","right":"f9a97d7d"};